import ENVIRONMENT_VARIABLES from '../environmentVariables';
export var onPressHelp = function onPressHelp() {
  var helpLink = "".concat(ENVIRONMENT_VARIABLES.ZENDESK_URL);
  var win = window.open(helpLink, '_blank');
  if (win != null) {
    win.focus();
  }
};